import { z } from 'zod';

// Schema per le coordinate
const CoordinatesSchema = z.object({
  lat: z.number().min(-90).max(90),
  lng: z.number().min(-180).max(180)
});

// Schema per i contatti
const ContactSchema = z.object({
  type: z.enum(['email', 'instagram', 'x', 'linkedin', 'facebook', 'website', 'telegram']),
  value: z.string().min(1, 'Il valore del contatto è obbligatorio')
});

// Schema per gli equipment (array di ID)
const EquipmentSchema = z.array(z.number()).optional();

// Schema principale per la creazione di un LivePal
export const CreateLivePalFormSchema = z.object({
  name: z.string().min(2, 'Il nome del locale è obbligatorio').max(100, 'Il nome non può superare i 100 caratteri'),
  address: z.string().min(3, 'L\'indirizzo è obbligatorio').max(200, 'L\'indirizzo non può superare i 200 caratteri'),
  zipCode: z.string().regex(/^[0-9]{5}$/, 'Il codice postale deve essere di 5 cifre'),
  city: z.string().min(1, 'La città è obbligatoria').max(100, 'La città non può superare i 100 caratteri'),
  region: z.string().min(1, 'La regione è obbligatoria').max(100, 'La regione non può superare i 100 caratteri'),
  country: z.string().min(1, 'Il paese è obbligatorio').max(100, 'Il paese non può superare i 100 caratteri'),
  website: z.string().url('Inserisci un URL valido').optional().or(z.literal('')),
  email: z.string().email('Inserisci un\'email valida').optional().or(z.literal('')),
  capacity: z.number().min(1, 'La capacità deve essere almeno 1').max(10000, 'La capacità non può superare 10000'),
  venueType: z.enum(['acoustic', 'fullBand'], {
    required_error: 'Seleziona il tipo di venue'
  }),
  accommodation: z.boolean(),
  meals: z.boolean(),
  coordinates: CoordinatesSchema,
  contacts: z.array(ContactSchema).optional(),
  equipment: EquipmentSchema
});

// Tipo TypeScript derivato dallo schema
export type CreateLivePalFormData = z.infer<typeof CreateLivePalFormSchema>; 